/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-07 15:20:09
 * @LastEditTime: 2022-01-29 18:19:19
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/index.jsx
 */
import { Tabs } from 'antd'
import React from 'react'
import PageWrap from '../../components/PageWrap'
import HSBList from './HSBList'
import WFTList from './WFTList'
import ReconciliationList from './ReconciliationList'
import SZRMBList from './SZRMBList'
import YLPayOrderSummaryList from './YLPayOrderSummaryList'
import YLSharingPayOrderSummaryList from './YLSharingPayOrderSummaryList'

const PlatformAccountingRecord = (props) => {

    return (
        <PageWrap>
            <Tabs animated={false}>
                <Tabs.TabPane key={1} tab="平台对账" >
                    <ReconciliationList />
                </Tabs.TabPane>
                <Tabs.TabPane key={2} tab="银联对账汇总列表"  >
                    <YLPayOrderSummaryList />
                </Tabs.TabPane>
                <Tabs.TabPane key={3} tab="银联分账系统对账单" >
                    <YLSharingPayOrderSummaryList />
                </Tabs.TabPane>
                <Tabs.TabPane key={4} tab="数币对账单" >
                    <SZRMBList />
                </Tabs.TabPane>
                <Tabs.TabPane key={5} tab="惠市宝对账单" >
                    <HSBList />
                </Tabs.TabPane>
                {/*<Tabs.TabPane key={6} tab="威富通对账单" >*/}
                {/*    <WFTList />*/}
                {/*</Tabs.TabPane>*/}
            </Tabs>
        </PageWrap>
    )
}

export default PlatformAccountingRecord


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/index.jsx